import { Box, BoxProps, Flex, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

import { Asterisk } from '$components/ui/asterisk';

interface SectionProps extends Omit<BoxProps, 'title'> {
  dataScroll?: string;
  eyebrow?: string;
  title?: ReactNode;
  showAsterisk?: boolean;
  children: ReactNode;
}

export function Section({
  dataScroll,
  eyebrow,
  title,
  showAsterisk = true,
  children,
  ...props
}: SectionProps) {
  return (
    <Box
      as="section"
      data-scroll={dataScroll}
      id={dataScroll}
      scrollMarginTop="100px"
      py={{ base: '56px', md: '88px' }}
      {...props}
    >
      {eyebrow && (
        <Flex align="center" gap="14px" mb="20px">
          {showAsterisk && <Asterisk size="12px" />}
          <Text
            fontFamily="mono"
            fontSize="11px"
            letterSpacing="0.18em"
            textTransform="uppercase"
            color="text.muted"
          >
            {eyebrow}
          </Text>
          <Box flex="1" h="1px" bg="line.subtle" />
        </Flex>
      )}

      {title && (
        <Box
          as="h2"
          fontFamily="display"
          fontWeight="500"
          fontSize={{ base: '40px', md: '56px' }}
          lineHeight="1.05"
          letterSpacing="-0.02em"
          color="text.primary"
          mb="32px"
        >
          {title}
        </Box>
      )}

      {children}
    </Box>
  );
}
